import styled from 'styled-components'

export const VerticalScrollbar = styled.div<{
    $hasOverflow?: boolean
    $showActionButtons?: boolean
    $verticalScrollBarVerticalPadding: number
    $verticalScrollBarLeftPadding: number
}>`
    display: grid;
    gap: 4px;
    padding-top: ${(p) => p.$verticalScrollBarVerticalPadding}px;
    padding-bottom: ${(p) => p.$verticalScrollBarVerticalPadding}px;
    padding-left: ${(p) => p.$verticalScrollBarLeftPadding}px;
    grid-auto-flow: column;
    grid-template: ${(p) =>
            p.$showActionButtons ? 'auto 1fr auto' : '1fr'} / 1fr;
    //padding: 1rem;
    place-items: center;

    opacity: ${(p) => (p.$hasOverflow ? '1' : '0')};
`
export const VerticalTrackAndThumb = styled.div<{ $scrollbarWidth: number }>`
    display: block;
    height: 100%;
    position: relative;
    width: ${(p) => p.$scrollbarWidth}px;
    border-radius: ${(p) => Math.floor(p.$scrollbarWidth) / 2}px;

    background-color: ${(p) => p.theme.colors.lighterGrey};
`

export const VerticalTrack = styled.div<{
    $isDragging?: boolean
    $scrollbarWidth: number
}>`
    top: 0;
    bottom: 0;
    cursor: ${(p) => (p.$isDragging ? 'grabbing' : undefined)};
    position: absolute;
    width: ${(p) => p.$scrollbarWidth}px;
    border-radius: ${(p) => Math.floor(p.$scrollbarWidth) / 2}px;
`

export const VerticalThumb = styled.div<{
    $height: number
    $isDragging?: boolean
    $scrollbarWidth: number
}>`
    position: absolute;
    height: ${(p) => `${p.$height}px`};
    cursor: ${(p) => (p.$isDragging ? 'grabbing' : 'grab')};

    width: ${(p) => p.$scrollbarWidth}px;
    border-radius: ${(p) => Math.floor(p.$scrollbarWidth / 2)}px;
    background-color: ${(p) => p.theme.colors.primaryGreen};
`
